<template>
  <div>
    <svg :height="svgHeight" viewBox="0 0 600 600" :width="svgWidth">
      <g>
        <path
          :class="color"
          d="M332.2,65.5c6.8,2.8,11.7,6.9,14.8,12.1c3.1,5.2,4.8,11.2,5.1,18c0.3,6.8-0.4,14-2.1,21.6
		c-1.7,7.6-4,15.1-6.8,22.5c-2.8,7.4-6,14.3-9.5,20.8c-3.5,6.5-6.7,12-9.5,16.5c-18.7,29.1-39.1,53.3-61.3,72.5
		c-22.2,19.2-47,35.2-74.4,47.9c-4.5,12.4-8.1,23.8-10.6,34.1c-2.5,10.3-4.5,20-5.9,29c30.5-4,55.8-2.5,75.9,4.2
		c8.5,2.8,16.5,8,24,15.5c7.5,7.5,13.5,15.5,18,24.2c4.5,8.6,7.1,16.9,7.6,24.8c0.6,7.9-1.8,13.7-7.2,17.4c0-10.5-3-19.4-9.1-26.7
		c-6.1-7.3-14.3-13.1-24.6-17.4c-10.3-4.2-22.5-6.8-36.7-7.6c-14.1-0.8-29.2,0.2-45.2,3.2c-16,3-32.6,7.8-50,14.6
		c-17.4,6.8-34.6,15.5-51.5,26.3c-2.8,2-6.4,1.5-10.8-1.5c-4.4-3-8.3-6.8-11.7-11.4c-3.4-4.7-5.8-9.4-7.2-14.2
		c-1.4-4.8-0.6-8.3,2.5-10.6c13.6-6.5,27.1-12.4,40.5-17.6c13.4-5.2,26.5-9.5,39.2-12.9c0.8-8.8,2.6-18.7,5.3-29.9
		c2.7-11.2,5.6-22.4,8.7-33.7c-1.7,0.6-5.2,1-10.4,1.3c-5.2,0.3-11.1,0.5-17.6,0.6c-6.5,0.1-13.2,0-20.1-0.4
		c-6.9-0.4-13.1-1.2-18.4-2.3c-11.3-2.5-20-7.3-26.1-14.4c-6.1-7.1-10.2-14.5-12.3-22.3c-2.1-7.8-2.5-14.9-1.3-21.4
		c1.3-6.5,3.5-10.3,6.6-11.4c-0.3,5.7,1.7,10.6,5.9,14.8c4.2,4.2,9.8,7.8,16.5,10.6c6.8,2.8,14.4,5.2,22.9,7c8.5,1.8,17,3,25.4,3.6
		c8.5,0.6,16.3,0.6,23.5,0.2c7.2-0.4,13.1-1.3,17.6-2.8c8.2-22.9,17.3-45.5,27.3-67.8c10-22.3,22.7-45.1,37.9-68.3
		c5.7-9,12.5-18.6,20.6-28.6c8.1-10,17-18.8,26.7-26.3c9.8-7.5,20.4-12.9,31.8-16.1C307.8,59.9,319.7,60.7,332.2,65.5z M276.6,125.7
		c-7.4,9.3-14.6,19.5-21.8,30.5c-7.2,11-14.1,22.3-20.8,33.7c-6.6,11.4-12.8,22.8-18.4,33.9c-5.7,11.2-10.3,21.6-14,31.2
		c10.5-4.2,21.1-10.6,32-19.1c10.9-8.5,21.2-18.1,31-28.8c9.8-10.7,18.7-22,26.7-33.9c8.1-11.9,14.6-23.5,19.7-34.8
		c6.8-14.7,11-26.4,12.7-35.2c1.7-8.8,1.1-14-1.9-15.7c-3-1.7-8.3,0.5-15.9,6.6C298.3,100.2,288.5,110.7,276.6,125.7z"
        />
        <path
          :class="color"
          d="M405.1,271.1c1.7-1.1,3.2-1,4.7,0.4c1.4,1.4,2.4,3.3,3,5.7c0.6,2.4,0.6,4.9,0,7.6c-0.6,2.7-1.8,4.6-3.8,5.7
		c-9.3,7.4-20.3,12-32.9,14c-12.6,2-25.2,1.8-37.9-0.4c5.7,4.2,9.6,9.7,11.9,16.3c2.3,6.6,3.3,13.9,3.2,21.8
		c-0.1,7.9-1.3,16.2-3.4,24.8c-2.1,8.6-4.7,17-7.8,25c-3.1,8.1-6.5,15.5-10.2,22.5c-3.7,6.9-7.1,12.6-10.2,17.2
		c-5.7,8.5-12.3,13.2-19.9,14.2c-7.6,1-16.3,0.4-25.9-1.9c-5.7-1.1-9.9-3.4-12.7-6.8c-2.8-3.4-4.9-7.3-6.1-11.7
		c-1.3-4.4-1.9-9-1.9-14s0.3-9.5,0.8-13.8c0.8-7.6,3.2-18.2,7-31.6c3.8-13.4,8.6-28.3,14.4-44.5c5.8-16.3,12.4-33.1,19.9-50.5
		c7.5-17.4,15.5-33.9,24-49.6c8.5-15.7,17.2-29.7,26.3-42.2c9-12.4,17.9-21.8,26.7-28c2.8-2,6.5-1.9,11,0.2
		c4.5,2.1,8.7,5.2,12.5,9.1c3.8,4,6.6,8.1,8.3,12.5c1.7,4.4,1,7.8-2.1,10.4c-7.1,5.1-13.9,11.2-20.6,18.2
		c-6.6,7.1-12.9,14.7-18.9,22.9c-5.9,8.2-11.3,16.7-16.1,25.4c-4.8,8.8-8.8,17.4-11.9,25.9c5.4,2.5,11.2,4.3,17.4,5.3
		c6.2,1,12.4,1.3,18.4,0.8c6.1-0.4,11.9-1.6,17.6-3.4C395.5,277.1,400.6,274.5,405.1,271.1z M294.4,418.3c3.7-4.2,7.3-9.8,11-16.7
		c3.7-6.9,7-14.2,10-21.8s5.4-15.3,7.2-22.9c1.8-7.6,2.6-14.4,2.3-20.4c0-3.1-0.4-6.3-1.1-9.5c-0.7-3.2-2.1-6.4-4-9.5
		c-1.1,2-2.5,5-4,9.1c-1.6,4.1-3.1,8.5-4.7,13.1c-1.6,4.7-3,9.1-4.5,13.4c-1.4,4.2-2.5,7.6-3.4,10.2c-2.8,8.8-5.2,17.9-7.2,27.3
		C294.2,400,293.6,409.2,294.4,418.3z"
        />
        <path
          :class="color"
          d="M564.5,266.9c2.8-1.4,4.9-1.3,6.4,0.2c1.4,1.6,2,3.8,1.9,6.8c-0.1,3-1.1,6.3-2.8,10c-1.7,3.7-4.4,6.8-8.1,9.3
		c-11,6.8-21.3,13.5-30.7,20.1c-9.5,6.6-18.6,13.6-27.3,21c-4,3.1-6.9,6.6-8.9,10.6c-5.7,11.6-12.3,24.5-19.9,38.6
		c-7.6,14.1-16,27.6-25,40.5c-9,12.9-18.5,24.4-28.4,34.6c-9.9,10.2-19.6,17.1-29.3,20.8c-3.7,1.4-8.8,1.3-15.3-0.2
		c-6.5-1.6-12.4-4.4-17.6-8.5c-5.2-4.1-8.9-9.3-11-15.7s-0.6-13.6,4.5-21.8c6.5-10.5,15.4-21.3,26.7-32.4
		c11.3-11.2,22.7-21.6,34.1-31.2c11.4-9.6,21.6-18.1,30.5-25.4c8.9-7.3,14.1-12.4,15.5-15.3c1.4-2.8,3-6.4,4.9-10.8
		c1.8-4.4,3.6-8.9,5.3-13.6c1.7-4.7,3.4-9.2,5.1-13.6c1.7-4.4,3-8.1,3.8-11.2c-4.2,7.1-9.1,14.2-14.6,21.4s-11.1,14.1-16.7,20.6
		c-5.7,6.5-11.4,12.4-17.2,17.8c-5.8,5.4-11.2,9.8-16.3,13.1c-3.1,2-7.2,2.5-12.3,1.7s-10-2.5-14.6-5.1s-8.5-5.7-11.7-9.5
		c-3.1-3.8-4.2-7.7-3.4-11.7c1.4-7.1,3.6-15.2,6.6-24.4c3-9.2,6.4-18.5,10.4-28c4-9.5,8.5-18.6,13.6-27.3
		c5.1-8.8,10.5-16.5,16.1-23.3c2-2.3,5.2-3.1,9.5-2.5c4.4,0.6,8.6,1.9,12.7,4c4.1,2.1,7.3,4.7,9.5,7.8c2.3,3.1,2.1,6.1-0.4,8.9
		c-3.4,4-7.6,10.2-12.5,18.7c-4.9,8.5-9.4,17-13.4,25.4c-4,8.5-6.9,15.8-8.7,22c-1.8,6.2-1.5,9,1.1,8.5c2.5-0.6,6.2-3.5,11-8.9
		c4.8-5.4,10.2-12,16.1-19.9c5.9-7.9,12.2-16.6,18.7-26.1c6.5-9.5,12.6-18.6,18.2-27.3c5.7-8.8,10.7-16.6,15.1-23.5
		c4.4-6.9,7.4-11.9,9.1-15.1c1.7-2.5,4.5-3.7,8.5-3.6c4,0.1,8.1,1.1,12.3,3c4.2,1.8,7.8,4.2,10.8,7c3,2.8,4.2,5.5,3.6,8.1
		c-0.8,5.9-2.3,12.9-4.5,20.8c-2.1,7.9-4.5,16-7,24.4c-2.5,8.3-4.9,16.3-7.2,23.7c-2.3,7.5-4.1,13.8-5.5,18.9
		c10.5-7.6,19.2-13.8,26.3-18.4C549.1,276,556.6,271.4,564.5,266.9z M373.3,453.5c4.5-3.4,9.3-7.6,14.4-12.5
		c5.1-4.9,10.1-10.4,15.1-16.3c4.9-5.9,9.7-12,14.2-18.2c4.5-6.2,8.5-12.3,11.9-18.2c-5.1,4.8-10.8,10.4-17.2,16.7
		c-6.4,6.4-12.3,12.6-17.8,18.9c-5.5,6.2-10.2,12-14.2,17.4C375.7,446.5,373.6,450.6,373.3,453.5z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "listifyIconSvg",
  props: {
    width: Number,
    height: Number,
    color: String,
  },
  computed: {
    svgWidth: function () {
      if (this.width && this.width > 0) {
        return this.width;
      }
      return "100%";
    },
    svgHeight: function () {
      if (this.height && this.height > 0) {
        return this.height;
      }
      return "100%";
    },
  },
};
</script>

<style type="text/css">
.primary {
  fill: var(--v-primary-base);
}

.background {
  fill: var(--v-background-base);
}
</style>